import { CenterAlgolia } from '@/types/models'

export const shouldShowDistanceLabel = (
  center: CenterAlgolia,
  isNearbyFeed: boolean
) => {
  return (
    (!!center?._rankingInfo?.geoDistance && isNearbyFeed) ||
    !!center?._rankingInfo?.matchedGeoLocation?.distance
  )
}
